import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class TiposFrutaView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "", producto_Id: 0 };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != "",
            producto_Id: this.state.model.producto_Id != 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/productos', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const responceData = await response.json();
        console.log("load_productos", responceData);
        this.setState({ productos: responceData, loading: false });
        //return responceData;
    }
    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/tiposFruta/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup className="col col-md-12">
                            <Label for="producto_Id">
                                <FormattedMessage id='Producto' />
                            </Label>
                            <Input
                                id="producto_Id"
                                name="producto_Id"
                                type="select"
                                onChange={this.handleChange}
                                valid={this.getValidationValue(this.state.modelValidation.producto_Id)}
                                invalid={!this.getValidationValue(this.state.modelValidation.producto_Id)}
                            >
                                <option value="0"></option>
                                {this.state.productos.map(producto => producto.producto_Id == this.state.model.producto_Id ? (
                                    <option value={producto.producto_Id} selected>
                                        {producto.nombre}
                                    </option>
                                ) : (<option value={producto.producto_Id}>{producto.nombre}</option>))}
                            </Input>
                            <FormFeedback>
                                {this.state.model.producto_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup className="col col-md-12">
                            <Label for="Nombre">
                                <FormattedMessage id='Nombre' />
                            </Label>
                            <FormattedMessage id='Nombre'>
                                {(placeholder) =>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        placeholder={placeholder}
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.model.nombre}
                                        valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                    />
                                }
                            </FormattedMessage>
                            <FormFeedback>
                                {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' /> }
                            </FormFeedback>
                        </FormGroup>
                        
                    </Form>
                </Row>
            </div>
        );
    }

}